
<div class="d-flex flex-column w-50 mx-auto bg-light p-3">

     <div class="mb-3">
        <div class="form-label">{{ 'Game.SpecialAge' | translate:locale.language }}</div>
        <dx-number-box [(value)]="wrResult.result1" stylingMode="filled" [showSpinButtons]="true"
            [showClearButton]="false" min=6 max="120">
            <dx-validator>
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dx-validator>
        </dx-number-box>
    </div>
    <div class="mb-3">
        <div class="form-label">{{ 'Game.Job' | translate:locale.language }}</div>
        <dx-text-box stylingMode="filled" [(value)]="wrResult.sentence1">
        </dx-text-box>
    </div>
    <div class="mb-3">
        <div class="form-label">{{ 'Game.Hand' | translate:locale.language }}</div>
        {{ 'Game.Left' | translate:locale.language }}: <input style="margin-right: 2em;" class="form-check-input" [checked]="wrResult.result2 === 0" value="0"
        (click)="onHandChanged(0)" type="radio" name="flexRadioDefault"
        id="flexRadioDefault1" />

        {{ 'Game.Right' | translate:locale.language }}: <input class="form-check-input" [checked]="wrResult.result2 === 1" value="1"
        (click)="onHandChanged(1)" type="radio" name="flexRadioDefault"
        id="flexRadioDefault0" />

    </div>
    
</div>


